'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function filepath(file) {
  return '/data/' + file.folder_id + '/' + encodeURIComponent(file.name);
}
function mp3path(file) {
  if (file.mime !== 'audio/mp3') {
    return filepath(file) + '.mp3';
  }
  return filepath(file);
}
function aiffpath(file) {
  return filepath(file) + '.aiff';
}
function pngpath(file) {
  return filepath(file) + '.png';
}

exports.filepath = filepath;
exports.mp3path = mp3path;
exports.pngpath = pngpath;
exports.aiffpath = aiffpath;


//////////////////
// WEBPACK FOOTER
// ./client/vendor/paths.js
// module id = 121
// module chunks = 0